import React, { FunctionComponent } from 'react';
import { faCamera, faImage } from '@fortawesome/pro-regular-svg-icons';
import { ActionsPopup } from 'components/UI/ActionsPopup/ActionsPopup';

export interface MobilePhotoSourceSheetLabels {
    photoGallery?: string;
    camera?: string;
}

export interface MobilePhotoSourceSheetProps {
    open: boolean;
    onClose: () => void;
    onPhotoGallery: () => void;
    onCamera: () => void;
    labels?: MobilePhotoSourceSheetLabels;
}

const DEFAULT_LABELS = {
    photoGallery: 'Photo Gallery',
    camera: 'Camera'
} as const;

export const MobilePhotoSourceSheet: FunctionComponent<MobilePhotoSourceSheetProps> = props => {
    if (!props.open) {
        return null;
    }

    const l = { ...DEFAULT_LABELS, ...props.labels };

    return (
        <ActionsPopup
            onClose={props.onClose}
            actions={[
                {
                    label: l.photoGallery,
                    icon: faImage,
                    onClick: props.onPhotoGallery
                },
                {
                    label: l.camera,
                    icon: faCamera,
                    onClick: props.onCamera
                }
            ]}
        />
    );
};

export default MobilePhotoSourceSheet;
